var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-home",on:{"click":_vm.toHome}},[_c('van-icon',{attrs:{"name":"wap-home","size":"20","color":"#2F78DC"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }